import styled from "styled-components/macro";

import { colors } from "UI/colors";

export const PanelDescription = styled.div`
  opacity: ${(props) => (props.disabled ? 0.65 : 1)};
  border-bottom: 1px solid ${colors.fnGray200};
  padding-bottom: 20px;
  margin-bottom: -16px;
`;
